<div class="header">
	<div class="back-button" (click)="goBack()">
		<span class="freud-icon freud-icon-arrow-left freud-icon-xs"></span>
		{{ 'PROMPTUARY.GOBACK' | translate }}
	</div>

	<div class="headline">
		<div class="contact-name">{{ promptuary.customerName }}</div>

		<div class="wrap-group">
			<div class="zk-flex zk-items-center">
				<div class="date">
					<span
						class="freud-icon freud-icon-calendar-event freud-icon-sm"
					></span>
					<div class="value">
						{{ promptuary.dayOfSession | date: 'd MMM yy' }}
					</div>
				</div>

				<div class="hour">
					<span class="freud-icon freud-icon-sm freud-icon-clock"></span>
					<div class="value">
						{{ promptuary.dayOfSession | date: "H'h'mm" }}
					</div>
				</div>
			</div>
			<div class="zk-flex zk-flex-col" *ngIf="promptuary.professional">
				<span class="professional-name">{{
					promptuary.professional.displayName
				}}</span>
				<span
					class="professional-crm"
					*ngIf="
						promptuary.professional &&
						!!promptuary.professional.formattedLicense
					"
					>{{ formatMainType() }} ({{
						promptuary.professional.formattedLicense
					}})</span
				>
			</div>
		</div>
	</div>
</div>

<div class="body">
	<div class="title">{{ 'PROMPTUARY.TITLE' | translate }}</div>
	<div class="zk-flex zk-gap-2 zk-items-center zk-mb-4">
		<span class="freud-icon freud-icon-shield-check"></span>
		<div class="subtitle">{{ 'PROMPTUARY.SUBTITLE' | translate }}</div>
	</div>

	<div class="field">
		<div class="name">{{ 'PROMPTUARY.REASONS' | translate }}</div>
		<div id="session-reasons-tags" class="zk-flex zk-flex-wrap zk-gap-2">
			<freud-tag
				*ngFor="let label of sessionReasonsLabels"
				outline
				[value]="label"
				size="lg"
			></freud-tag>
		</div>
	</div>

	<div *ngIf="promptuary.complaintAndDuration" class="field">
		<div class="name">
			{{ 'PROMPTUARY.COMPLAINT_AND_DURATION' | translate: { name: firstName } }}
		</div>
		<div class="content">
			{{ promptuary.complaintAndDuration }}
		</div>
	</div>

	<div class="field">
		<div class="name">
			{{ 'PROMPTUARY.EVOLUTION_RECORD.TITLE' | translate }}
		</div>
		<div *ngIf="promptuary.serviceEvolution" class="content">
			{{ promptuary.serviceEvolution }}
		</div>

		<div
			*ngIf="
				!promptuary.serviceEvolution && !promptuary.serviceEvolutionPsychiatrist
			"
			class="pill--empty"
		>
			{{ 'PROMPTUARY.EMPTY_FIELD' | translate }}
		</div>

		<div *ngIf="promptuary.serviceEvolutionPsychiatrist">
			<p *ngFor="let record of getPsychiatristRecords()" class="record">
				<span class="content"
					>{{ getPsychiatristRecordTranslation(record.key) }}:
					{{ record.value }}</span
				>
			</p>
		</div>
	</div>

	<div *ngIf="promptuary.serviceEvolutionPsychiatrist" class="field">
		<div class="name">{{ 'PROMPTUARY.PSYCHIC_EXAMINATION' | translate }}</div>
		<div *ngIf="promptuary.psychicExamination" class="content">
			{{ promptuary.psychicExamination }}
		</div>

		<div *ngIf="!promptuary.psychicExamination" class="pill--empty">
			{{ 'PROMPTUARY.EMPTY_FIELD' | translate }}
		</div>
	</div>

	<div *ngIf="promptuary.serviceEvolutionPsychiatrist" class="field">
		<div class="name">{{ 'PROMPTUARY.CLINICAL_EXAMINATION' | translate }}</div>
		<div *ngIf="promptuary.clinicalExamination" class="content">
			{{ promptuary.clinicalExamination }}
		</div>

		<div *ngIf="!promptuary.clinicalExamination" class="pill--empty">
			{{ 'PROMPTUARY.EMPTY_FIELD' | translate }}
		</div>
	</div>

	<div *ngIf="promptuary.icd10?.length" class="field">
		<div class="name">{{ 'PROMPTUARY.ICD' | translate }}</div>
		<p *ngFor="let icd of promptuary.icd10" class="record">
			<span class="content">{{ icd.description }}</span>
		</p>
	</div>

	<promptuary-cgi
		[clientId]="clientId"
		[appointmentId]="appointmentId"
		service="view"
	></promptuary-cgi>

	<div
		class="field"
		*ngIf="
			promptuary.alarmSignals !== undefined && promptuary.alarmSignals !== null
		"
	>
		<div class="name">{{ 'PROMPTUARY.ALARM_SIGNALS' | translate }}</div>
		<div class="content">
			{{
				(promptuary.alarmSignals
					? 'PROMPTUARY.ALARM_SIGNALS_YES'
					: 'PROMPTUARY.ALARM_SIGNALS_NO'
				) | translate
			}}.
			<span *ngIf="!!promptuary.alarmSignalsReason && promptuary.alarmSignals"
				>&nbsp;{{ promptuary.alarmSignalsReason }}</span
			>
		</div>
	</div>

	<div class="field" *ngIf="promptuary.conduct">
		<div class="name">{{ 'PROMPTUARY.CONDUCT' | translate }}</div>
		<div class="content">
			{{ promptuary.conduct }}
		</div>
	</div>

	<div class="field" *ngIf="promptuary.outcome">
		<div class="name">{{ 'PROMPTUARY.OUTCOME' | translate }}</div>
		<div class="content">
			{{ promptuary.outcome }}
		</div>
	</div>

	<div class="field" *ngIf="promptuary.outcomeForwardJourney">
		<div class="name">{{ 'PROMPTUARY.WHATS_JOURNEY' | translate }}</div>
		<div class="content journey-type">
			{{
				'PROMPTUARY.JOURNEY_TYPES.' + promptuary.outcomeForwardJourney
					| translate
			}}
		</div>
	</div>

	<div class="field" *ngIf="promptuary.outcomeSpecialty">
		<div class="name">{{ 'PROMPTUARY.WHATS_SPECIALTY' | translate }}</div>
		<div class="content">
			{{ getSpecialties(promptuary.outcomeSpecialty) }}
		</div>
	</div>

	<div class="field" *ngIf="promptuary.outcomeReason">
		<div class="name">
			{{
				(promptuary.outcomeSpecialty
					? 'PROMPTUARY.WHATS_SPECIALTY_REASON'
					: 'PROMPTUARY.WHATS_REASON'
				) | translate
			}}
		</div>
		<div class="content">
			{{ promptuary.outcomeReason }}
		</div>
	</div>
	
	<div class="field" *ngIf="promptuary.outcomeOtherSpecialty">
		<div class="name">{{ 'PROMPTUARY.WHATS_SPECIALTY_OTHER' | translate }}</div>
		<div class="content">
			{{ promptuary.outcomeOtherSpecialty }}
		</div>
	</div>

	<div class="field" *ngIf="promptuary.outcomeOtherSpecialty">
		<div class="name">{{ 'PROMPTUARY.WHATS_SPECIALTY_OTHER' | translate }}</div>
		<div class="content">
			{{ promptuary.outcomeOtherSpecialty }}
		</div>
	</div>

	<!-- <div class="field" *ngIf="task?.description" id="promptuary-task">
		<div class="name">{{ 'PROMPTUARY.TASK.VIEW_TITLE' | translate }}</div>
		<div>
			<div class="name">{{ 'PROMPTUARY.TASK.ORIENTATIONS' | translate }}</div>
			<div class="content">
				{{ task.description }}
			</div>
		</div>
		<div class="name zk-mt-2">{{ 'PROMPTUARY.TASK.LINKS' | translate }}</div>
		<div *ngIf="task?.attachments?.length > 0">
			<div class="content links-wrapper">
				<a
					target="_blank"
					rel="noopener noreferrer"
					*ngFor="let link of task?.attachments"
					[href]="link.specifications.url"
					>{{ link.specifications.url }}</a
				>
			</div>
		</div>
	</div> -->

	<div class="register-stamp">
		{{
			'PROMPTUARY.REGISTERED_AT'
				| translate
					: {
							day: (promptuary.registeredAt | date: 'dd/MM/yyyy'),
							hour: (promptuary.registeredAt | date: "H'h'")
					  }
		}}
	</div>
</div>

<div class="footer">
	<div class="title">
		{{ 'PROMPTUARY.DOCUMENTARY_REGISTER_TITLE' | translate }}
	</div>
	<div class="zk-flex zk-gap-2 zk-items-center">
		<span class="freud-icon freud-icon-shield-check"></span>
		<div
			class="subtitle"
			[innerHTML]="'PROMPTUARY.DOCUMENTARY_REGISTER_SUBTITLE' | translate"
		></div>
	</div>
	<autosave-textarea
		*ngIf="appointmentId && clientId"
		[appointment]="autoSaveData"
		placeholder="{{ 'PROMPTUARY.PLACEHOLDERS.NOTES' | translate }}"
		property="session-note"
		service="saveDocumentaryRecord"
	></autosave-textarea>
</div>
